module.exports = __webpack_public_path__ + "img/ambotis2017-min.7f0cba07.jpg";